// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".editor{\r\n margin-bottom: 20%;\r\n}", "",{"version":3,"sources":["webpack://src/components/PrivacyPolicy/Page.css"],"names":[],"mappings":"AAAA;CACC,kBAAkB;AACnB","sourcesContent":[".editor{\r\n margin-bottom: 20%;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
